module.exports = __webpack_public_path__ + "static/img/question5-1.6cec8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question5-1.png
// module id = /1iy
// module chunks = 1